import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PaymentDetailModel, PaymentMessageHistory} from '../../../models/payment/paymentDetail.model';

@Component({
  selector: 'app-paycard-detail',
  templateUrl: './payment-detail-modal.component.html',
  styleUrls: ['./payment-detail-modal.component.scss']
})
export class PaymentDetailModalComponent {
  @Input() set payment(p: PaymentDetailModel) {
    this.currentPayment = p;
    this.messages = this.convertMessages(p.messageHistory);
  }

  currentPayment: PaymentDetailModel;
  messages: { date: Date, message: string }[] = null;
  showMessages = false;

  constructor(
    private activeModal: NgbActiveModal,
  ) {
  }

  onCloseModal() {
    this.activeModal.dismiss();
  }

  toggleMessages() {
    this.showMessages = !this.showMessages;
  }

  private convertMessages(history: PaymentMessageHistory): { date: Date, message: string }[] {
    let result: { date: Date, message: string }[] = null;
    if (history) {
      result = [];
      const keys = Object.keys(history);
      result = keys.map(timestamp => {
        const date = new Date(+timestamp);
        const message = history[timestamp];
        try {
          return { date, message: JSON.parse(message) };
        } catch (e) {
          console.log(e);
          return { date, message };
        }
      });
      result.sort(((a, b) => b.date.getTime() - a.date.getTime()));
    }
    return result;
}
}
